import { EventDetails } from '../components/EventDetails/EventDetails.types';

export const eventDetailsData: EventDetails[] = [
  {
    id: 1,
    img: '/images/pages/Events/icon-calendar.svg',
    text: '18 November — 20 November 2024',
  },
  {
    id: 2,
    img: '/images/pages/Events/icon-location.svg',
    text: 'Dubai Exhibition Centre, Expo City,',
  },
  {
    id: 3,
    text: 'Dubai, United Arab Emirates',
    link: 'https://www.google.com/maps/place//@24.9633625,55.1558468,15z?entry=ttu&g_ep=EgoyMDI0MDgyMS4wIKXMDSoASAFQAw%3D%3D',
  },
];